<template>
	<div class="container400">
		<div class="form_control">
			<h3 style="color:#ffffff;">Forget Password</h3>
		</div>
		<div v-on:keyup.enter = "sendPWReset">
			<div class="form_control">
				<label for="input-email">Email</label>
				<input type="text" class="font-20" placeholder="Email Address" v-model.trim = "email">

				<div class="error" style="font-weight:700;">
					{{errorMsg}}
					{{successMsg}}
				</div>
			</div>
		</div>
		<div class="form_control">
			<div class="btn" @click = "sendPWReset">
				Submit 
			</div>
		</div>
	</div>
</template>

<script>
var md5 = require('md5');
var uuid = require('uuid/v5');
var dbPath = "signup";
var itemTemplate;
export default {
	//==============================================//
	//												//
	//					DATA						//
	//												//
	//==============================================//
	data() {
		return {
			// ERROR MESSAGE
			errorMsg: "",

			// FORM
			email: "",
			successMsg: "",
			errorMsg: "",

			// PLACEHOLDER
		}
	},
	firestore(){
	},
	created(){

	},
	mounted(){
          setTimeout(()=>{
            customJS.runAll();
          },30);
	},
	updated(){

	},



	//==============================================//
	//												//
	//					METHODS						//
	//												//
	//==============================================//
	methods:{
		//----------------------------- REGISTER -----------------------------//
		sendPWReset(){
			this.successMsg = "";
			this.errorMsg = "";
			myFB.auth.sendPasswordResetEmail(this.email).then(() =>{
				this.successMsg = "Submitted successfully, please check your email for the reset password link."
			})
			.catch(err =>{
				this.errorMsg = err.message;
			})
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/Profile/ForgetPW.vue